<script lang="ts">
  import { resolve } from '$app/paths'
  import { POINTS_LEVEL } from '$lib/session/points'
  import { getHelpPath } from '$lib/utils/general'
  import FlameIcon from '~icons/tabler/flame'
  import InfoIcon from '~icons/tabler/help'

  interface Props {
    points: number
    multiplier: number
  }

  let { points, multiplier }: Props = $props()

  let level = $derived(Math.trunc(points / POINTS_LEVEL) + 1)
  let isMaxMultiplier = $derived(multiplier >= 10)
</script>

<div class="info">
  <h3>
    <span class="current">Level {level}</span>
    {#if multiplier > 1}
      <span class="multiplier" class:max={isMaxMultiplier}>
        <FlameIcon />
        <span>
          x{multiplier}
        </span>
      </span>
    {/if}
    <a
      class="learn-more"
      target="_blank"
      href={resolve(getHelpPath('product/point-and-level-system'))}
      title="Learn more"
    >
      <InfoIcon />
    </a>
  </h3>
  <div
    class="progress-wrapper"
    style:--_progress={(points % POINTS_LEVEL) / POINTS_LEVEL}
  >
    <div class="progress"></div>
    <svg
      class="indicator"
      width="5"
      height="5"
      viewBox="0 0 5 5"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M 0 0 H 5 L 2.5 5 Z" fill="currentColor" />
    </svg>
  </div>
</div>

<style lang="postcss">
  h3 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 0.5rem;
    font-size: var(--scale-0);
    line-height: 100%;
  }

  .progress-wrapper {
    position: relative;
    margin-block-start: 1rem;
    width: 100%;
    height: 0.375rem;
    --_extend: 0rem;
    .progress {
      position: absolute;
      inset: 0 calc(0px - var(--_extend));
      border-radius: var(--radius-full);
      background: color-mix(in oklab, currentColor, transparent 85%);
      overflow: hidden;
      &::after {
        position: absolute;
        inset: 0 auto 0 0;
        background: currentColor;
        width: calc(100% * var(--_progress));
        content: '';
      }
    }
    .indicator {
      position: absolute;
      bottom: calc(100% + 0.0625rem);
      left: calc(
        (0px - var(--_extend)) + (100% + 2 * var(--_extend)) * var(--_progress)
      );
      translate: -50% 0;
    }
  }

  @keyframes wobble {
    0%,
    100% {
      transform: rotate(-10deg);
    }
    50% {
      transform: rotate(10deg);
    }
  }

  .multiplier {
    display: flex;
    flex: 1;
    justify-content: flex-start;
    align-items: center;
    gap: 0.125em;
    margin-left: -0.3em;
    color: var(--color-text-brand);
    font-size: var(--scale-000);
    font-family: var(--font-code);

    &.max {
      :global(svg) {
        transform-origin: bottom center;
        animation: wobble 1.5s ease-in-out infinite;
      }
      :global(path) {
        fill: currentColor;
        stroke: none;
      }
    }
  }

  a.learn-more {
    display: block;
    opacity: 0.2;
    color: currentColor;
    font-size: var(--scale-0);
    :global(svg) {
      display: block;
    }
  }
</style>
